export default __webpack_public_path__ + "static/media/greenAvatar.cee5add1.svg";